<template>
  <div>
    <FormSection title="2. Please direct my gift to:">
      <div class="directgift__section">
        <div class="directgift__option">
          <input
            id="needed"
            name="giftdirect"
            type="radio"
            class="frequency"
            @click="customSelected = false"
          />
          <FormLabel for="needed" value="needed"
            >Please use my gift where it is needed most</FormLabel
          >
        </div>
        <div class="directgift__option">
          <input
            id="program"
            type="radio"
            name="giftdirect"
            class="frequency"
            @click="customSelected = true"
          />
          <FormLabel for="program" value="program">Please direct my gift to:</FormLabel>
        </div>
      </div>

      <FormRow class="designation" v-if="customSelected">
        <FormCol field="custom.designation" :showLabel="false">
          <FormSelect>
            <option selected="selected" value="OU">Select a Designation</option>
            <option value="OUIsrael">OU Israel emergency campaign</option>
            <option value="NCSY">
              JSU emergency campaign
            </option>
            <option value="JLIC">OU-JLIC US emergency fund</option>
            <option value="JLIC2">OU-JLIC Israel emergency fund</option>
            <option value="TeachCoalition">Project Protect</option>
            <option value="Advocacy">Advocacy</option>
          </FormSelect>
        </FormCol>
      </FormRow>
    </FormSection>

    <div v-if="customSelected">
      <FormSection v-if="getValue('applications.0.department') == 'OUIsrael'">
        <p>
          SUPPORT OUR COMMUNITIES IN ISRAEL - With rockets continuing to rain down upon Israel, the Orthodox Union is quickly responding to help acheinu beit Yisrael.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'NCSY'">
        <p>
          Jewish students are under threat at their own public high schools. THEY NEED YOUR HELP NOW!
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'JLIC'">
        <p>
          Now is the time to protect Jewish students on campus. You’ve seen it in the news and maybe even in your neighborhood: Antisemitism and hate are rising. College campuses across the country are either allowing groups to support terrorism or turning a blind eye to the issue. Jewish students feel unsafe and unheard, and they worry about what will happen if they speak up.
        </p>
      </FormSection>
      <FormSection v-else-if="getValue('applications.0.department') == 'TeachCoalition'">
        <p>
          Project Protect will advocate for $1 billion nationally in government security funding for at-risk nonprofits in the coming year. 
        </p>
      </FormSection>
      </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { getValue, setValue, form } = usePaymentForm();

    const customSelected = ref(false);

    watch(
      () => getValue("custom.designation"),
      (val) => {
        if (val == "OUIsrael" || !val) {
          setValue("applications.0.department", "OUIsrael");
          setValue("applications.0.campaign", "Iron Swords - Israel Emergency Fund");
        } else  if(val == "NCSY" || !val){
          setValue("applications.0.department", "NCSY");
          setValue("applications.0.campaign", "Emergency JSU");
        }else  if(val == "JLIC" || !val){
          setValue("applications.0.department", "JLIC");
          setValue("applications.0.campaign", "Students Under Attack");
        }else  if(val == "JLIC2" || !val){
          setValue("applications.0.department", "JLIC");
          setValue("applications.0.campaign", "JLIC Chesed");
          setValue("applications.0.subCampaign", "Emergency Response Fund");
        }else  if(val == "TeachCoalition" || !val){
          setValue("applications.0.department", "TeachCoalition");
          setValue("applications.0.campaign", "Project Protect");
        }else  if(val == "Advocacy" || !val){
          setValue("applications.0.department", "Advocacy");
          setValue("applications.0.campaign", "General Donation");
        } else {
          setValue("applications.0.department", "OU");
          setValue("applications.0.campaign", "General Donation");
        }
      }
    );

    return {
      getValue,
      customSelected,
    };
  },
});
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 100%;
    max-width: 100%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
.directgift__section {
  margin-bottom: 15px;
}

.directgift__option {
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>
